import { connect } from "react-redux";
import { DialysisDragDropQuestion as Component } from "@learningblocks/storybook-components";
import {
  onDialysisUpdate,
  onDialysisSelect,
  onCloseFeedback,
  onDialysisSubmit,
  onDialysisReset,
} from "./store/actions";

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    dialysisTable: ownProps.dialysisTable,
    dialysisTablePrediction: state.dialysisDragDrop?.predicts[ownProps.id],
    enableSubmit: state.dialysisDragDrop?.predicts[ownProps.id]?.enableSubmit,
    feedbackType: state.dialysisDragDrop?.predicts[ownProps.id]?.feedbackType,
    dialysisConcentration: state.dialysisConcentration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onDialysisUpdate: (data) => {
      dispatch(onDialysisUpdate(data));
    },
    onDialysisSelect: (data) => {
      dispatch(onDialysisSelect(data));
    },
    closeFeedback: (data) => {
      dispatch(onCloseFeedback(data));
    },
    onSubmit: (data) => {
      dispatch(onDialysisSubmit(data));
    },
    onReset: (data) => {
      dispatch(onDialysisReset(data));
    },
  };
}

export const DialysisDragDropQuestion = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
